// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3bmKO","productName":"Table_productName__1SLAu"};